import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { getBrand } from "../lib/brand";

const LOGO = "/angel-logo-white.png";

export default function Privacidad() {
  const brand = getBrand();
  const domain = brand.domain;
  const email = brand.contactEmail;
  return (
    <div style={{ background: "#FFF", minHeight: "100vh", color: "#1f2937" }}>
      <Helmet>
        <title>{`Política de Privacidad — ${brand.name}`}</title>
        <meta name="description" content={`Política de privacidad de ${brand.name}. Cómo recolectamos, usamos y protegemos tu información personal.`} />
        <link rel="canonical" href={`${brand.seo.canonical}privacidad`} />
      </Helmet>

      <header style={{ background: "#163680", padding: "20px 0", textAlign: "center" }}>
        <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <img src={LOGO} alt={brand.name} style={{ height: 50 }} />
          <span style={{ color: "white", fontWeight: 800, fontSize: 22, lineHeight: 1.05 }}>
            {brand.shortName}<br /><small style={{ color: "#7DC242", fontSize: 13 }}>{brand.tagline}</small>
          </span>
        </Link>
      </header>

      <main style={{ maxWidth: 800, margin: "0 auto", padding: "40px 24px", lineHeight: 1.7 }}>
        <h1 style={{ color: "#163680", fontSize: 32, marginBottom: 8 }}>Política de Privacidad</h1>
        <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 32 }}>Última actualización: 26 de junio de 2026</p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>1. Quiénes somos</h2>
        <p>
          <strong>{brand.name}</strong> es una membresía transfronteriza que ofrece servicios de asistencia
          24/7 (vial, médica, ambulancia y legal) para familias en México, contratada principalmente por
          mexicanos viviendo en Estados Unidos. Operamos desde el dominio <a href={`https://${domain}`}>{domain}</a>.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>2. Qué información recolectamos</h2>
        <ul>
          <li><strong>Datos del titular:</strong> nombre completo, email, teléfono y dirección en Estados Unidos.</li>
          <li><strong>Datos del beneficiario en México:</strong> nombre, parentesco, teléfono, dirección, fecha de nacimiento, sexo, tipo de sangre, condiciones médicas (hipertensión, diabetes, etc.), alergias, medicamentos y contacto de emergencia.</li>
          <li><strong>Datos de pago:</strong> los procesa Stripe; nosotros NO almacenamos números de tarjeta.</li>
          <li><strong>Datos de uso:</strong> historial de solicitudes y chequeos de salud.</li>
        </ul>

        <h2 style={{ color: "#163680", marginTop: 32 }}>3. Para qué usamos tu información</h2>
        <ul>
          <li>Procesar tu membresía y pagos.</li>
          <li>Despachar servicios de asistencia cuando los solicites (compartiremos los datos del beneficiario con el proveedor del servicio en México, ej. grúa o ambulancia, sólo en el momento del despacho).</li>
          <li>Enviarte notificaciones transaccionales (bienvenida, recibos, actualizaciones de solicitudes).</li>
          <li>Mejorar nuestros servicios y atender consultas de soporte.</li>
        </ul>

        <h2 style={{ color: "#163680", marginTop: 32 }}>4. Con quién compartimos tu información</h2>
        <p>Sólo con los siguientes terceros y bajo el principio de mínima información necesaria:</p>
        <ul>
          <li><strong>Stripe</strong> (procesamiento de pagos)</li>
          <li><strong>Resend</strong> (envío de emails transaccionales)</li>
          <li><strong>Proveedores de asistencia en México</strong> (sólo cuando solicitas un servicio activo)</li>
          <li><strong>NuraLogix / Anura</strong> (si activas el add-on de Chequeo de Salud — los datos se procesan en sus servidores certificados HIPAA)</li>
        </ul>
        <p>
          <strong>Nunca vendemos ni rentamos tu información personal a terceros</strong> con fines de marketing.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>5. Programa de referidos</h2>
        <p>
          Si invitas a un amigo a través de nuestro sistema, sólo guardamos su nombre y email
          el tiempo necesario para enviar la invitación. Si tu amigo se registra, vinculamos su cuenta a la tuya
          para otorgarte la recompensa. Si no se registra en 90 días, eliminamos su email de nuestros registros.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>6. Datos médicos sensibles</h2>
        <p>
          Los datos médicos de tus beneficiarios (condiciones, medicamentos, alergias) son tratados con el
          máximo cuidado. Sólo el personal autorizado y los proveedores médicos en México que despachen un
          servicio tienen acceso a ellos, y siempre con un propósito específico de asistencia.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>7. Tus derechos</h2>
        <p>Tienes derecho a:</p>
        <ul>
          <li><strong>Acceder</strong> a la información que tenemos de ti</li>
          <li><strong>Corregir</strong> datos inexactos</li>
          <li><strong>Eliminar</strong> tu cuenta y datos asociados</li>
          <li><strong>Exportar</strong> tus datos en formato JSON</li>
          <li><strong>Oponerte</strong> a usos específicos de tus datos</li>
        </ul>
        <p>
          Para ejercer cualquiera de estos derechos, escríbenos a <strong>{email}</strong> y
          responderemos en menos de 72 horas.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>8. Seguridad</h2>
        <p>
          Tu información viaja siempre por canales cifrados (HTTPS/TLS 1.3). Las contraseñas se guardan con
          hash bcrypt (no podemos leerlas, ni siquiera nosotros). Hacemos backups diarios y mantenemos
          registros de auditoría de cualquier cambio en datos médicos.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>9. Permisos de la app móvil</h2>
        <p>Si usas nuestra aplicación móvil (Play Store o PWA), te podemos pedir los siguientes permisos:</p>
        <ul>
          <li><strong>Cámara</strong> — sólo si activas el módulo de Chequeo de Salud (Anura) para realizar la lectura facial de signos vitales.</li>
          <li><strong>Contactos</strong> — sólo si decides invitar amigos desde tu directorio (opcional, puedes escribirlos manualmente).</li>
          <li><strong>Ubicación</strong> — opcional, sólo si decides compartirla al momento de pedir asistencia.</li>
          <li><strong>Notificaciones</strong> — para alertarte sobre el estado de tus solicitudes y vencimientos de membresía.</li>
        </ul>
        <p>Puedes revocar cualquier permiso en cualquier momento desde la configuración de tu dispositivo.</p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>10. Niños menores de 13 años</h2>
        <p>
          Nuestro servicio está dirigido a adultos. No recolectamos intencionalmente datos de menores de 13 años
          como titulares. Sin embargo, los menores pueden estar registrados como <em>beneficiarios</em> (por ejemplo, hijos
          de un titular que vive en EEUU), siempre con autorización del titular.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>11. Cambios en esta política</h2>
        <p>
          Si actualizamos esta política, te avisaremos por email al menos 15 días antes de que entren en vigor
          los cambios importantes. Tu uso continuo del servicio después de los cambios constituye tu aceptación.
        </p>

        <h2 style={{ color: "#163680", marginTop: 32 }}>12. Contacto</h2>
        <p>
          ¿Dudas, sugerencias o ejercicio de derechos? Escríbenos a:<br />
          📧 <strong>{email}</strong><br />
          🌐 <a href={`https://${domain}`}>{domain}</a>
        </p>

        <hr style={{ margin: "40px 0", border: "none", borderTop: "1px solid #e7eaf2" }} />
        <p style={{ fontSize: 13, color: "#9ca3af", textAlign: "center" }}>
          © 2026 {brand.name} · <Link to="/" style={{ color: "#163680" }}>Inicio</Link>
        </p>
      </main>
    </div>
  );
}
